import { t } from 'i18next';
import { UseFormRegister, UseFormSetValue } from 'react-hook-form';
import { ControlledTextField } from '@frontend/features/common/components/ControlledTextField';
import { Box, Typography } from '@mui/material';
import React from 'react';
import { PaxDto } from '@bandido/shared/dtos';

interface Props {
  register: UseFormRegister<PaxDto>;
  setValue: UseFormSetValue<PaxDto>;
  control: any;
}

export const CartPaxForm: React.FC<Props> = ({
  control,
  register,
}) => (   
  <Box
    display="flex"
    flexDirection="column"
    gap={3}
  >
    <input {...register('id')} type="hidden" />
        
    <Box display="flex" flexDirection="column" gap={1}>
      <Typography variant='subtitle2' color="text.primary">{t('saleOrder.view.passengers.form.name')}</Typography>
      <ControlledTextField
        shrink
        control={control}
        name="name"
        required
        errorMessage={t('common.form.required')}
        size="small"
      />
    </Box>
    
    <Box display="flex" flexDirection="column" gap={1}>
      <Typography variant='subtitle2' color="text.primary">{t('saleOrder.view.passengers.form.lastName')}</Typography>
      <ControlledTextField
        shrink
        control={control}
        name="lastName"
        required
        errorMessage={t('common.form.required')}
        fullWidth
        size="small"
      />
    </Box>
    
    <Box display="flex" flexDirection="column" gap={1}>
      <Typography variant='subtitle2' color="text.primary">{t('saleOrder.view.passengers.form.birthDate')}</Typography>
      <ControlledTextField
        shrink
        required
        fullWidth
        control={control}
        name="dob"
        type="date"
        size="small"
        errorMessage={t('common.form.required')}
      />
    </Box>
    
    <Box display="flex" flexDirection="column" gap={1}>
      <Typography variant='subtitle2' color="text.primary">{t('saleOrder.view.passengers.form.email')}</Typography>
      <ControlledTextField
        shrink
        control={control}
        name="email"
        type="email"
        size="small"
        fullWidth
      />
    </Box>
    
    <Box display="flex" flexDirection="column" gap={1}>
      <Typography variant='subtitle2' color="text.primary">{t('saleOrder.view.passengers.form.phone')}</Typography>
      <ControlledTextField
        shrink
        control={control}
        name="phone"
        type="tel"
        size="small"
        fullWidth
      />
    </Box>
  </Box>
);
